var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sd_info"},[_c('div',{staticClass:"sd_info__content"},_vm._l((_vm.sd_info),function(item,item_key){return _c('div',{key:item_key,staticClass:"sd_info__content content-item"},[_c('div',{staticClass:"left"}),_c('div',{staticClass:"right"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(item))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }